import LayoutMain from '@Layouts/LayoutMain';
import usePage from '@Queries/usePage';
import Page from '@Components/Page';
import PageTopBar from '@Components/PageTopBar';
import Banner from './elements/Banner';
import Rules from './elements/Rules';
import AdditionalRules from './elements/AdditionalRules';
import Questions from './elements/Questions';
import BonusTypes from './elements/BonusTypes';
import Gallery from './elements/Gallery';
import Footnotes from './elements/Footnotes';
import styles from './PageDivanClub.module.css';

import type { FC } from 'react';
import type { BreadcrumbData } from '@Types/Breadcrumbs';
import type { BannerData } from './elements/Banner';
import type { RulesData } from './elements/Rules';
import type { AdditionalRulesData } from './elements/AdditionalRules';
import type { BonusTypesData } from './elements/BonusTypes';
import type { QuestionsData } from './elements/Questions';
import type { GalleryData } from './elements/Gallery';
import type { FootnotesData } from './elements/Footnotes';

export interface DivanClubPage {
  breadcrumbs: BreadcrumbData[];
  banner: BannerData;
  rules: RulesData;
  additionalRules?: AdditionalRulesData;
  bonusTypes: BonusTypesData;
  questions: QuestionsData;
  gallery: GalleryData;
  footnotes: FootnotesData;
}

const PageDivanClub: FC = () => {
  const { data: page } = usePage<DivanClubPage>();

  return (
    <LayoutMain>
      <Page>
        <PageTopBar breadcrumbs={page.breadcrumbs} />
        <div className={styles.page} data-testid='page-divan-club'>
          <Banner banner={page.banner} />
          <Rules className={styles.container} rules={page.rules} />
          {page.additionalRules && <AdditionalRules rules={page.additionalRules} />}
          <BonusTypes className={styles.container} bonusTypes={page.bonusTypes} />
          <Questions className={styles.container} questions={page.questions} />
          <Gallery className={styles.gallery} gallery={page.gallery} />
          <Footnotes className={styles.container} footnotes={page.footnotes} />
        </div>
      </Page>
    </LayoutMain>
  );
};

export default PageDivanClub;
